export default __webpack_public_path__ + "public/assets/images/f4db52cf173d9df5810fdc2c40e54caa.png";